var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getDate)?_c('span',{staticClass:"task-name-time"},[_vm._v("\n  "+_vm._s(this.$t('msg.by'))+" "),_c('date-string',{attrs:{"value":_vm.getDate,"short":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }